/*jshint esversion: 6 */
import { Aurelia, inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { UserMessageService } from "services/userMessageService";
import { AccountAPI } from "services/accountAPI";
import { CookieHelper } from "services/cookieHelper";

@inject(Aurelia, Router, AccountAPI, UserMessageService, CookieHelper)
export class AuthService {
  constructor(app, router, accountApi, userMessageService, cookieHelper) {
    this.router = router;
    this.app = app;
    this.accountApi = accountApi;
    this.userMessageService = userMessageService;
    this.user = null;
    this.account = null;
    this.user = JSON.parse(sessionStorage["magnfi_user"] || null);
    this.account = JSON.parse(sessionStorage["magnfi_account"] || null);
    this.accountChangeCallBack = [];
    this.sub_error = null;
    this.whitelabel = JSON.parse(sessionStorage["magnfi_whiteLabel"] || null);
    this.cookie = cookieHelper;
  }

  login(
    email,
    password,
    confirm_token,
    url = null,
    vendasta_user_id = null,
    vendasta_acc_id = null,
    vendasta_product_id = null
  ) {
    let params = new URL(document.location).searchParams;
    let outlookParam = "";
    if (params) {
      outlookParam = params.get("_host_Info");
    }

    if (!outlookParam) {
      outlookParam = params.get("action");
    }

    this.url = url;
    this.accountApi.login(
      email,
      password,
      confirm_token,
      this.loginSuccess.bind(this),
      this.loginError.bind(this),
      vendasta_user_id,
      vendasta_acc_id,
      outlookParam,
      vendasta_product_id
    );
  }

  loginSSO(token, url = null) {
    this.url = url;
    this.accountApi.loginWithSSOToken(
      token,
      url,
      this.loginSuccess.bind(this),
      this.loginError.bind(this)
    );
  }

  sendPasswordReset(email) {
    this.accountApi.sendPasswordReset(
      email,
      this.sendPasswordResetSuccess.bind(this),
      this.loginError.bind(this)
    );
  }

  loginWithResetPassword(email, password, reset_token) {
    this.accountApi.loginWithResetPassword(
      email,
      password,
      reset_token,
      this.loginSuccess.bind(this),
      this.loginError.bind(this)
    );
  }

  logout() {
    this.user = null;
    this.account = null;
    sessionStorage["magnfi_user"] = null;
    sessionStorage["magnfi_account"] = null;
    sessionStorage["magnfi_whiteLabel"] = null;
    if (this.cookie.getCookie("kml") == 1) {
      this.cookie.resetKeepmeLoggedin();
    }
    this.router.navigate("#/visitor");
  }

  loginSuccess(
    user,
    account = null,
    is_trial_expired = null,
    whitelabel = null,
    redirect_url = null
  ) {
    this.setUser(user);
    this.setAccount(account);
    this.setWhitelabel(whitelabel);
    this.setTrial(is_trial_expired);

    localStorage["magnfi_username"] = user.email;

    if (is_trial_expired == 1 || is_trial_expired == 2) {
      let params = new URL(document.location).searchParams;
      // eslint-disable-next-line no-unused-vars
      let outlookParam = "";
      console.log("outlook params ==================>", params);
      if (params) {
        outlookParam = params.get("_host_Info");
        if (!outlookParam) {
          outlookParam = params.get("action");
        }
      }
      var origin = window.location.origin;
      // alert(outlookParam)
      // alert(window.location.href)
      // this.userMessageService.setUserMessage('login', window.location.href);
      // this.userMessageService.setUserMessage('user', window.location.href);
      // $.getScript("https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js").then(function(){
      //   Office.onReady(function(){
      //     Office.context.ui.messageParent(JSON.stringify({ user, account}), { targetOrigin: origin });
      //   });
      // });

      // return

      if (outlookParam) {
        $.getScript(
          "https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js"
        ).then(function () {
          Office.onReady(function () {
            Office.context.ui.messageParent(JSON.stringify({ user, account }), {
              targetOrigin: origin,
            });
          });
        });
      } else {
        if (this.url) {
          // this.router.navigate(this.url);
          window.location.href =
            location.origin +
            (location.origin == "http://localhost:9000"
              ? "/index_old.html"
              : "") +
            this.url;
        } else if (redirect_url) {
          // this.router.navigate(redirect_url);
        } else this.router.navigate("#/user");
      }
    } else {
      this.router.navigate("#/visitor/trialExpired");
    }
  }

  loginError(msg) {
    this.userMessageService.setUserError("login", msg);
  }

  sendPasswordResetSuccess() {
    this.userMessageService.setUserMessage(
      "login",
      "Password Recovery Email Sent!"
    );

    setTimeout(
      function () {
        this.router.navigate("#/visitor", { replace: true });
      }.bind(this),
      2500
    );
  }

  isLoggedIn() {
    return this.user !== null;
  }

  getUser() {
    return this.user;
  }

  setUser(user) {
    this.user = user;

    if (user) {
      sessionStorage["magnfi_user"] = JSON.stringify(user);
      localStorage.setItem("token", user.token);
    } else {
      sessionStorage["magnfi_user"] = null;
      localStorage.setItem("token", null);
    }

    //ga('set', 'userId', this.user.email);
  }

  getAccount() {
    return this.account;
  }

  setAccount(account) {
    this.account = account;
    if (account) {
      sessionStorage["magnfi_account"] = JSON.stringify(account);
    } else {
      sessionStorage["magnfi_account"] = null;
    }

    this.accountChange();
  }

  setWhitelabel(whitelabel) {
    this.whitelabel = whitelabel;

    if (whitelabel) {
      sessionStorage["magnfi_whiteLabel"] = JSON.stringify(whitelabel);
    } else {
      sessionStorage["magnfi_whiteLabel"] = null;
    }
  }

  getWhitelabel() {
    return this.whitelabel;
  }

  setTrial(is_trial_expired) {
    this.is_trial_expired = is_trial_expired;
  }

  getTrial() {
    return this.is_trial_expired;
  }

  registerAccountChangeCallback(callback) {
    this.accountChangeCallBack.push(callback);
  }

  accountChange() {
    for (var i = 0; i < this.accountChangeCallBack.length; i++) {
      this.accountChangeCallBack[i]();
    }
  }

  accountClosed() {
    this.account.status = 3;
    this.accountChange();
  }

  setSubError(error) {
    this.sub_error = error;
  }

  getSubError() {
    return this.sub_error;
  }
}
